<template>
  <v-container
    fluid
    tag="section"
    class="modal-bank-account"
  >
    <v-row justify="start">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="440"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            class="display-1"
            color="primary"
            dark
            v-on="on"
            @click="showModal()"
          >
            Добавить
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="headline">
            Добавить Расчетный счет
            <v-btn
              color="green darken-1"
              text
              class="close-btn"
              @click="closeModal()"
            >
              <v-icon>
                close
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <form>
              <!-- Банк -->
              <v-col
                cols="12"
                class="py-0"
              >
                <v-select
                  v-model="selectedBank"
                  v-validate="'required'"
                  :disabled="! hasBanks || form.id !== 0"
                  :items="parsedBanks"
                  :error-messages="errors.collect('bank')"
                  item-text="name"
                  item-value="alias"
                  label="Банк"
                  data-vv-name="bank"
                  prepend-icon="mdi-warehouse"
                  color="purple darken-2"
                  required
                />
              </v-col>

              <!-- Название счета -->
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-text-field
                  v-model="form.name"
                  v-validate="'required|min:5'"
                  :error-messages="errors.collect('titleBankAccount')"
                  label="Название счета"
                  data-vv-name="titleBankAccount"
                  validate-on-blur
                  required
                  color="purple darken-2"
                  clearable
                  prepend-icon="mdi-account-edit"
                />
              </v-col>

              <!-- Номер счета -->
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-text-field
                  v-model="form.account_number"
                  v-validate="'required|numeric|min:9|max:34'"
                  :error-messages="errors.collect('numberBankAccount')"
                  label="Номер счета"
                  data-vv-name="numberBankAccount"
                  validate-on-blur
                  required
                  color="purple darken-2"
                  clearable
                  prepend-icon="mdi-account-edit"
                />
              </v-col>

              <!-- Номер мфо -->
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-text-field
                  v-model="form.mfo"
                  v-validate="'required|numeric|digits:6'"
                  :error-messages="errors.collect('mfo')"
                  label="Мфо"
                  data-vv-name="mfo"
                  validate-on-blur
                  required
                  color="purple darken-2"
                  clearable
                  prepend-icon="mdi-account-edit"
                />
              </v-col>

              <!-- Овердрафт -->
              <v-col
                cols="12"
                class="pb-0"
              >
                <v-text-field
                  v-model="form.overdraft"
                  v-validate="'required|numeric'"
                  :error-messages="errors.collect('overdraft')"
                  label="Овердрафт"
                  data-vv-name="overdraft"
                  validate-on-blur
                  required
                  color="purple darken-2"
                  clearable
                  prepend-icon="mdi-account-edit"
                />
              </v-col>

              <!-- Валюта -->
              <v-col
                cols="12"
                class="py-0"
              >
                <v-select
                  v-model="form.currency"
                  v-validate="'required'"
                  :disabled="!! form.id"
                  item-text="text"
                  item-value="value"
                  :items="getCurrencyList"
                  :error-messages="errors.collect('currency')"
                  label="Валюта счета"
                  data-vv-name="currency"
                  prepend-icon="mdi-warehouse"
                  color="purple darken-2"
                  required
                />
              </v-col>

              <v-col
                cols="12"
                class="py-0 my-4 text-center"
              >
                <v-btn
                  class="mr-0"
                  color="#0051ff"
                  :disabled="errors.any() || isSendFormCompanyBankAccount"
                  @click="submit"
                >
                  Сохранить
                </v-btn>
              </v-col>
            </form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import { currency } from '../../../../service/helpers/Currency'
  import { mapGetters } from 'vuex'

  export default {
    name: 'ModalBankAccount',
    props: {
      dialog: {
        type: Boolean,
        default: false,
      },
      form: {
        type: Object,
      },
    },

    data () {
      return {
        selectedBank: 0,
      }
    },

    computed: {
      getCurrencyList () {
        return currency.listCurrency
      },
      ...mapGetters('banks', ['parsedBanks', 'isLoading', 'hasError', 'error', 'hasBanks']),
      ...mapGetters('companyBankAccount', ['isSendFormCompanyBankAccount', 'clearStateCompanyBankAccount']),
    },

    created () {
      this.$store.dispatch('banks/findAllBanks')
    },

    methods: {
      async submit () {
        const isValid = await this.$validator.validate()
        if (!isValid) {
          return
        }

        const formData = Object.assign({}, this.form)
        formData.bank_alias = formData.bank_alias === undefined ? this.selectedBank : formData.bank_alias
        this.$emit('submit', formData)
      },

      showModal () {
        this.$store.commit('companyBankAccount/clearStateCompanyBankAccount')
        this.$validator.reset()
        this.$emit('showModal')
      },

      closeModal () {
        this.$store.commit('companyBankAccount/clearStateCompanyBankAccount')
        this.$validator.reset()
        this.$emit('closeModal')
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
